import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { TravelAbroadState, setForWho, setTravelers } from '../../../store/travelAbroadSlice'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import MovingPrice from '../../../components/v2/MovingPrice'
import { AppState } from '../../../store/appSlice'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import Message from '../../../components/Message'
import { useSelector } from 'react-redux'
import { AuthState } from '../../../store/authSlice'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { Helmet } from 'react-helmet-async'
//
//
const WhoDoYouInsure = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  // travel regions first step list
  const { data: travelRegions, isLoading: isTravelRegionsLoading } =
    api.useGetPolicyRegistrationFirstStepQuery(undefined)
  //
  //
  const dispatch = useAppDispatch()
  //
  const { checkout, screenHeader, filter } = useAppSelector(
    (data: { travelAbroad: TravelAbroadState }) => data.travelAbroad,
  )
  //
  //
  const { t } = useTranslation()
  //
  //
  const navigate = useNavigate()
  //
  //
  // Check if at least one age is over 18
  const oneIsAdult = filter.travelersDate && filter.travelersDate?.map((x) => x.age)?.some((age) => age >= 18)
  //
  //
  const LoggedUserDateIsEqual =
    checkout?.forWho === 'travel-abroad-policy-registration-for-me' &&
    auth &&
    auth.user &&
    auth.user.birthday &&
    auth.user.birthday === filter.travelersDate?.[0]?.dateFormat &&
    oneIsAdult === true &&
    filter.travelersDate?.length === 1
      ? false
      : true
  //
  const LogOutUserDate =
    auth &&
    !auth.user &&
    checkout?.forWho === 'travel-abroad-policy-registration-for-me' &&
    oneIsAdult === true &&
    filter.travelersDate?.length === 1
      ? false
      : true
  //
  const forMeBoolean = auth && auth.user ? LoggedUserDateIsEqual : LogOutUserDate
  //
  //
  const forOtherBoolean =
    checkout?.forWho === 'travel-abroad-policy-registration-for-other' &&
    filter?.travelersDate &&
    filter?.travelersDate?.length >= 1
      ? false
      : true
  //
  //
  const forMeAndOther =
    checkout?.forWho === 'travel-abroad-policy-registration-for-me-and-other' &&
    filter?.travelersDate &&
    filter?.travelersDate?.length >= 2 &&
    oneIsAdult === true
      ? false
      : true
  //
  //
  const nextButtonValidation =
    checkout?.forWho === 'travel-abroad-policy-registration-for-me'
      ? forMeBoolean
      : checkout?.forWho === 'travel-abroad-policy-registration-for-other'
      ? forOtherBoolean
      : checkout?.forWho === 'travel-abroad-policy-registration-for-me-and-other'
      ? forMeAndOther
      : true
  //
  //
  const MainLoading = isTravelRegionsLoading
  //
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('WhoDoYouInsure')}</title>
        <meta name="description" content={`${t('WhoDoYouInsure')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={t('WhoDoYouInsure')} />

        <AbroadProgressBar stepName={`${t('forWho')}`} />

        <MovingPrice price={filter.offerTotalPrice} />

        <Cards>
          {travelRegions &&
            travelRegions?.map((item, index) => {
              return (
                <HorizontalCard
                  className="horizontal-card"
                  key={index}
                  title={item?.translations?.[lang]?.title}
                  description={item?.translations?.[lang]?.body}
                  imgUrl={item?.image}
                  selected={item.type === checkout.forWho ? true : false}
                  onClick={() => [dispatch(setForWho(item.type)), dispatch(setTravelers(undefined))]}
                />
              )
            })}

          {checkout.forWho === 'travel-abroad-policy-registration-for-me' &&
          auth &&
          auth.user &&
          auth.user.birthday !== filter.travelersDate?.[0]?.dateFormat ? (
            <Message
              style={{
                marginTop: '20px',
                marginInline: 'auto',
                maxWidth: '464px',
              }}
              variant="gray"
              text="დალოგინებული მომხმარებლის დაბადების თარიღი არ ემთხვევა თქვენს მიერ შეყვანილ თარიღს !"
            />
          ) : null}
        </Cards>

        <Buttons>
          <NavigationButton text={`${t('back')}`} buttonType="prev" onClick={() => navigate('/travel-offer')} />
          {}

          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={nextButtonValidation}
            onClick={() => {
              navigate(
                checkout.forWho === 'travel-abroad-policy-registration-for-me'
                  ? '/abroad-for-me'
                  : checkout.forWho === 'travel-abroad-policy-registration-for-other'
                  ? '/abroad-for-other'
                  : checkout.forWho === 'travel-abroad-policy-registration-for-me-and-other'
                  ? '/abroad-for-me-and-other'
                  : '',
              )
            }}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Cards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 0px;
  place-items: center;
  grid-row-gap: 24px;
  margin-top: 32px;

  ${Responsive.mobile} {
    margin-top: 24px;
    grid-row-gap: 20px;
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
//
export default WhoDoYouInsure
